export const LONG_REST_TEXT_SET = 'serviceData.LONG_REST_TEXT_SET';
